export default "__VITE_ASSET__CYoV9uhj__"